import Api from "../../../services/Api";

const BASE_URL = "/service/iqevse-csms/ocppFeatures/v1";

export const ocppFeaturesApi = {
  getAllFeatures: async () => {
    const response = await Api.get(`${BASE_URL}/getAllFeatures`);
    return response;
  },

  addFeatures: async features => {
    const response = await Api.post(`${BASE_URL}/addFeatures`, features);
    return response;
  },
};
